module.exports = __webpack_public_path__ + "media/images/workplace/instructions/knowhowDeBtn-4140759737805255157121f8a01be780.png";